import styled from "styled-components";

const SVGWrapper = styled.svg`
  width: 140px;
  @media (max-width: 640px) {
    width: 120px;
  }
`;

const Swimm_Logo = () => {
  return (
    <SVGWrapper
      viewBox="0 0 152 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M148.745 4.998a2.188 2.188 0 01-2.186-2.184c0-1.204.981-2.186 2.186-2.186 1.204 0 2.184.982 2.184 2.186s-.98 2.184-2.184 2.184zm0-4.998a2.817 2.817 0 00-2.814 2.814 2.816 2.816 0 002.814 2.813 2.817 2.817 0 002.814-2.813A2.817 2.817 0 00148.745 0z"
          fill="#253569"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M149.025 2.525a.56.56 0 01-.231.037h-.518v-.617h.531c.099 0 .173.012.222.04.088.048.133.14.133.28 0 .13-.046.216-.137.26zm.567 1.13a1.226 1.226 0 01-.012-.214v-.153c0-.161-.023-.281-.068-.361a.435.435 0 00-.224-.181.457.457 0 00.272-.224.686.686 0 00.04-.564.724.724 0 00-.115-.193.573.573 0 00-.215-.16.998.998 0 00-.363-.06h-1.1v2.3h.469v-.902h.47c.133 0 .225.023.273.073.05.048.074.146.076.293l.004.214a1.08 1.08 0 00.051.321h.53v-.057a.19.19 0 01-.088-.132zM88.39 33.841l-4.288-9.218-4.984 1.015-4.247 10.852-3.753-15.152-8.18 1.59 7.04 27.896 7.25-1.423 4.425-11.957 4.462 10.221 7.164-1.457 7.001-30.537-8.079 1.558-3.81 16.612zM102.862 31.043l8.095-1.574V.466l-8.095 1.593v28.984zM137.127 8.51l-7.611 10.036-7.513-7.098-7.287 1.418v29.25l8.013-1.557v-16.67l4.484 5.238 4.986-1.014 4.263-6.763v16.526l7.973-1.537V7.09l-7.308 1.42zM50.845 28.398l-4.254-9.422-5.015.975-4.249 11.097-3.79-15.544-8.143 1.657 7.014 27.578 7.257-1.411 4.444-11.652 4.461 9.921 7.158-1.394L62.756 9.86l-8.098 1.647-3.813 16.891zM15.498 17.273l-3.145-.263C9.5 16.764 9.5 16.323 9.5 15.896c0-.904 1.074-1.707 2.736-2.044 1.924-.391 2.924.176 2.974 1.686l.013.418 8.459-1.638-.014-.534c-.047-5.422-4.838-8.39-11.392-7.056C5.53 8.1.998 12.615.998 17.963c0 4.3 2.544 6.66 7.564 7.018l2.792.185c3.956.265 4.287 1.008 4.287 1.683 0 1.849-2.915 2.494-3.248 2.562-2.639.537-3.799-.29-3.878-2.766L8.5 26.38 0 28.019l.017.441c.25 6.576 4.862 9.594 12.336 8.074 7.098-1.443 11.867-6.264 11.867-11.996 0-4.405-2.852-6.782-8.722-7.265z"
          fill="#253569"
        ></path>
      </g>
    </SVGWrapper>
  );
};

export default Swimm_Logo;
